import { Row, Form } from "react-bootstrap";

import classes from "../../maintainers.module.scss";

import { ReactComponent as AddSvg } from "@/assets/images/icons/Estates/add.svg";
import { decimalValidateNew, formatMilesDecimalNew } from "@/services/Utils";

const TabWeight = ({ data, setData }) => {
	const handleChange = (field, index, value) => {
		let newValue = String(value).replaceAll(".", "");

		let newData = { ...data };
		let newWeights = [...data.weights];

		newWeights[index][field] = newValue;

		newData.weights = newWeights;
		setData(newData);
	};

	const handleAdd = () => {
		let newData = { ...data };
		let newWeights = [...data.weights];
		newWeights.push({ container_content: "", weight: "" });

		newData.weights = newWeights;
		setData(newData);
	};

	return (
		<Row className={`${classes.row_form} ${classes.list}`} style={{ marginTop: "10px" }}>
			<div>
				<div className={classes.button} onClick={() => handleAdd()}>
					<AddSvg className={classes.icon} />
					Nuevo Peso
				</div>
			</div>

			<table className={classes.table}>
				<thead className={classes.thead}>
					<tr>
						<td style={{ width: "30%" }}>Contenido Neto (cc o g)</td>
						<td>Peso Envase (g)</td>
					</tr>
				</thead>
				<tbody>
					{data &&
						data.weights &&
						data.weights.map((weight, i) => {
							return (
								<tr key={i}>
									<td>
										<Form.Control
											value={weight.container_content ? formatMilesDecimalNew(weight.container_content) : ""}
											onChange={(e) => handleChange("container_content", i, e.currentTarget.value)}
											type="text"
											style={{ textAlign: "right" }}
											onKeyDown={decimalValidateNew}
										/>
									</td>
									<td>
										<Form.Control
											value={weight.weight ? formatMilesDecimalNew(weight.weight) : ""}
											onChange={(e) => handleChange("weight", i, e.currentTarget.value)}
											type="text"
											style={{ textAlign: "right" }}
											onKeyDown={decimalValidateNew}
										/>
									</td>
								</tr>
							);
						})}
				</tbody>
			</table>
		</Row>
	);
};

export default TabWeight;
